export default __webpack_public_path__ + "static/media/img-4.805ef961.jpg";